import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgMediaUploaderModalComponent } from './ag-media-uploader-modal.component';
import { ButtonWithIndicatorModule } from '../button-with-indicator/button-with-indicator.module';
import { ModalWindowModule } from '../modal-window/modal-window.module';
import { AgTabsModule } from '../ag-tabs/ag-tabs.module';
import { UploadFromDiskTabComponent } from '././upload-from-disk-tab/upload-from-disk-tab.component';
import { DropZoneModule } from '../../components/drop-zone/drop-zone.module';
import { UploadFromUrlTabComponent } from './upload-from-url-tab/upload-from-url-tab.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FormsModule } from '@angular/forms';
import {
  DxButtonModule, DxDropDownBoxModule,
  DxFileUploaderModule,
  DxFormModule,
  DxTextBoxModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { SelectFromGalleryComponent } from './select-from-gallery/select-from-gallery.component';
import { AgMediaGalleryModule } from '../ag-media-gallery/ag-media-gallery.module';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { SharedModule } from '../../../shared/shared.module';
import { AGFileUploaderComponent } from './file-uploader/file-uploader.component';
import { MediaSourcesComponent } from './media-sources/media-sources.component';

@NgModule({
  declarations: [
    AgMediaUploaderModalComponent,
    UploadFromDiskTabComponent,
    UploadFromUrlTabComponent,
    SelectFromGalleryComponent,
    AGFileUploaderComponent,
    MediaSourcesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ModalWindowModule,
    AgTabsModule,
    DropZoneModule,
    ImageCropperModule,
    FormsModule,
    DxFormModule,
    DxTextBoxModule,
    DxButtonModule,
    ButtonWithIndicatorModule,
    DxFileUploaderModule,
    DxValidatorModule,
    ImagePreviewComponent,
    AgMediaGalleryModule,
    DxDropDownBoxModule,
  ],
  exports: [ AgMediaUploaderModalComponent, AGFileUploaderComponent,MediaSourcesComponent ],
  })
export class AgMediaUploaderModalModule {}
